import TaxonomyTerms from './TaxonomyTerms'

export default TaxonomyTerms
